import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

function ViewFranchise({ mode = "active" }) {

  const API = "";
  const modeConfig = {
    active: {
      status: "active",
      title: "Active Franchise",
      listTitle: "Active List",
      file: "active-franchises",
    },
    holdRejected: {
      status: "hold_rejected",
      title: "Hold/Reject Franchise",
      listTitle: "Hold/Reject List",
      file: "hold-reject-franchises",
    },
    blacklisted: {
      status: "blacklisted",
      title: "Blacklisted Franchise",
      listTitle: "Blacklisted List",
      file: "blacklisted-franchises",
    },
    total: {
      status: "all",
      title: "Total Franchise",
      listTitle: "Total Franchise List",
      file: "total-franchises",
    },
  };
  const currentMode = modeConfig[mode] || modeConfig.active;

const [data, setData] = useState([]);
const [selected, setSelected] = useState(null);
const [showView, setShowView] = useState(false);
const [search, setSearch] = useState("");
const [stateFilter, setStateFilter] = useState("");
const [districtFilter, setDistrictFilter] = useState("");
const [actionItem, setActionItem] = useState(null);
const [actionStatus, setActionStatus] = useState("");
const [actionRemark, setActionRemark] = useState("");
const [actionMenu, setActionMenu] = useState(null);
const tableExportRef = useRef(null);
const isActiveMode = mode === "active";
const isTotalMode = mode === "total";

const getAdminActor = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.name || user.admin_type || user.login_id || user.email || "Admin";
  } catch (error) {
    return "Admin";
  }
};

const formatStatus = (status) => {
  const normalized = String(status || "active").toLowerCase();
  const labels = {
    active: "Active",
    hold: "Hold",
    rejected: "Reject",
    blacklisted: "Blacklist",
  };
  return labels[normalized] || normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

const statusBadgeStyle = (status) => {
  const normalized = String(status || "active").toLowerCase();
  const styles = {
    active: { background: "#16a34a", color: "#ffffff" },
    hold: { background: "#facc15", color: "#713f12" },
    rejected: { background: "#dc2626", color: "#ffffff" },
    blacklisted: { background: "#111827", color: "#ffffff" },
  };
  return {
    ...(styles[normalized] || styles.active),
    boxShadow: "0 4px 10px rgba(15,23,42,0.12)",
  };
};

const actionLabel = (status) => {
  const labels = {
    active: "Reactivate",
    hold: "Hold",
    rejected: "Reject",
    blacklisted: "Blacklist",
  };
  return labels[status] || "Update";
};

const showToast = (icon, title, text = "") => Swal.fire({
  icon,
  title,
  text,
  timer: 2800,
  timerProgressBar: true,
  confirmButtonColor: icon === "error" ? "#dc2626" : icon === "warning" ? "#f59e0b" : "#16a34a",
});

const handleDownload = async () => {
  const element = document.querySelector(".print-area");

  const clone = element.cloneNode(true);

  const images = clone.querySelectorAll("img");

  for (let img of images) {
    try {
      const res = await fetch(img.src);
      const blob = await res.blob();

      const reader = new FileReader();

      await new Promise(resolve => {
        reader.onloadend = () => {
          img.src = reader.result;
          resolve();
        };
        reader.readAsDataURL(blob);
      });
    } catch (err) {}
  }

  html2pdf().set({
    margin: 10,
    filename: "franchise_details.pdf",
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
  }).from(clone).save();
};


const handlePrint = async () => {
  const element = document.querySelector(".print-area");

  const printWindow = window.open("", "", "width=800,height=900");

  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: serif; padding: 20px; }
          table { width: 100%; border-collapse: collapse; }
          table, td { border: 1px solid #000; padding: 5px; }
        </style>
      </head>
      <body>
        ${element.innerHTML}
      </body>
    </html>
  `);

  printWindow.document.close();

  setTimeout(() => {
    printWindow.print();
  }, 500);
};



  // 🔥 LOAD DATA
  const fetchData = () => {
    axios.get(`${API}/api/approved-franchises`, {
      params: { status: currentMode.status, _ts: Date.now() },
    })
      .then(res => setData(res.data));
  };

  useEffect(() => {
    fetchData();
  }, [mode]);

  const openLifecycleAction = (item, status) => {
    setActionMenu(null);
    setActionItem(item);
    setActionStatus(status);
    setActionRemark("");
  };

  const openActionMenu = (event, item) => {
    setActionMenu({ item });
  };

const submitLifecycleAction = async () => {
    if (!actionItem || !actionStatus) return;
    if (actionStatus !== "active" && !actionRemark.trim()) {
      showToast("warning", "Remark Required", "Please write a remark before updating this franchise.");
      return;
    }

    try {
      await axios.post(`${API}/api/franchises/${actionItem.id}/lifecycle-status`, {
        status: actionStatus,
        remark: actionRemark,
        updated_by: getAdminActor(),
      });
      setActionItem(null);
      setActionStatus("");
      setActionRemark("");
      fetchData();
      const label = actionLabel(actionStatus);
      showToast(
        "success",
        actionStatus === "active" ? "Franchise Reactivated" : `Franchise ${label} Done`,
        actionStatus === "active" ? "Old centre code and login ID remain unchanged." : `${actionItem.centre_name} has been marked as ${label}.`
      );
    } catch (error) {
      showToast("error", "Action Failed", error.response?.data?.message || "Please try again.");
    }
  };

  const openFranchiseLogin = async (item) => {
    try {
      const res = await axios.post(`${API}/api/admin/franchises/${item.id}/login-link`);
      const token = res.data?.token;
      if (!token) {
        showToast("error", "Login Failed", "Login link create failed.");
        return;
      }
      window.open(`/franchise-auto-login?token=${encodeURIComponent(token)}`, "_blank", "noopener,noreferrer");
    } catch (error) {
      showToast("error", "Login Failed", error.response?.data?.message || "Franchise login open failed.");
    }
  };

  const deleteFranchise = async (item) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Delete Franchise?",
      text: `${item.centre_name} will be removed from this list.`,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
    });
    if (!result.isConfirmed) return;

    try {
      await axios.delete(`${API}/api/franchises/${item.id}`);
      fetchData();
      showToast("success", "Deleted", "Franchise deleted successfully.");
    } catch (error) {
      showToast("error", "Delete Failed", error.response?.data?.message || "Franchise delete failed.");
    }
  };

  // 🔥 MODAL STYLE
  const exportColumns = [
    "Sl No",
    "Centre Name",
    "Centre Code",
    "State",
    "District",
    "Contact",
    "Status",
    "Updated By",
    "Remark",
  ];

  const buildExportRows = () => filteredData.map((item, index) => [
    index + 1,
    item.centre_name || "",
    item.centre_code || "",
    item.state_name || "",
    item.district_name || "",
    item.contact || "",
    item.status || "active",
    item.status_updated_by || "",
    item.status_remark || "",
  ]);

  const downloadBlob = (content, fileName, type) => {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const escapeCsvCell = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const escapeHtmlCell = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const exportCsv = () => {
    const rows = [exportColumns, ...buildExportRows()];
    const csv = rows.map((row) => row.map(escapeCsvCell).join(",")).join("\n");
    downloadBlob(csv, `${currentMode.file}.csv`, "text/csv;charset=utf-8;");
  };

  const exportExcel = () => {
    const rows = [exportColumns, ...buildExportRows()];
    const table = rows
      .map((row) => `<tr>${row.map((cell) => `<td>${escapeHtmlCell(cell)}</td>`).join("")}</tr>`)
      .join("");
    const html = `<html><head><meta charset="UTF-8"></head><body><table border="1">${table}</table></body></html>`;
    downloadBlob(html, `${currentMode.file}.xls`, "application/vnd.ms-excel;charset=utf-8;");
  };

  const exportTablePdf = () => {
    if (!tableExportRef.current) return;
    html2pdf().set({
      margin: 8,
      filename: `${currentMode.file}.pdf`,
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }
    }).from(tableExportRef.current).save();
  };

  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  };

  const modalContent = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "500px"
  };


  const filteredData = data.filter(item => {
  return (
    item.centre_name.toLowerCase().includes(search.toLowerCase()) &&
    (stateFilter === "" || item.state_name === stateFilter) &&
    (districtFilter === "" || item.district_name === districtFilter)
  );
});



  return (
    <DashboardLayout>

      <div className="container-fluid">

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div>
            <div className="text-uppercase fw-semibold text-primary" style={{ fontSize: "12px", letterSpacing: "0" }}>
              Franchise Management
            </div>
            <h3 className="mb-0">{currentMode.title}</h3>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button className="btn btn-outline-primary btn-sm" onClick={exportCsv} disabled={!filteredData.length}>
              Export CSV
            </button>
            <button className="btn btn-outline-success btn-sm" onClick={exportExcel} disabled={!filteredData.length}>
              Export Excel
            </button>
            <button className="btn btn-outline-danger btn-sm" onClick={exportTablePdf} disabled={!filteredData.length}>
              Export PDF
            </button>
          </div>
        </div>


        {/* Filter Data */}
        

            <div className="row g-3 mb-3 align-items-center">

                {/* SEARCH */}
                <div className="col-md-4">
                    <input
                    type="text"
                    className="form-control"
                    placeholder="Search Centre..."
                    onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* STATE FILTER */}
                <div className="col-md-3">
                    <select
                    className="form-control"
                    onChange={(e) => setStateFilter(e.target.value)}
                    >
                    <option value="">All States</option>
                    {[...new Set(data.map(i => i.state_name))].map((s, i) => (
                        <option key={i}>{s}</option>
                    ))}
                    </select>
                </div>

                {/* DISTRICT FILTER */}
                <div className="col-md-3">
                    <select
                    className="form-control"
                    onChange={(e) => setDistrictFilter(e.target.value)}
                    >
                    <option value="">All Districts</option>
                    {[...new Set(data.map(i => i.district_name))].map((d, i) => (
                        <option key={i}>{d}</option>
                    ))}
                    </select>
                </div>

                </div>




        {/* 🔥 TABLE */}
        <div
          ref={tableExportRef}
          className="bg-white border shadow-sm"
          style={{ borderRadius: "8px", overflow: "hidden" }}
        >
        <div
          className="px-3 py-2 d-flex justify-content-between align-items-center"
          style={{ background: "linear-gradient(90deg, #ecfeff 0%, #f0fdf4 55%, #fff7ed 100%)", borderBottom: "1px solid #bae6fd" }}
        >
          <strong style={{ color: "#0f172a" }}>{currentMode.listTitle}</strong>
          <span className="badge bg-light text-dark border">{filteredData.length} Records</span>
        </div>
        <div className="table-responsive" style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table className="table table-hover table-bordered align-middle mb-0" style={{ tableLayout: isTotalMode ? "auto" : "fixed", width: "100%", minWidth: isTotalMode ? "0" : "760px", borderColor: "#cbd5e1" }}>

  <thead style={{ background: "linear-gradient(90deg, #0f766e 0%, #2563eb 52%, #7c3aed 100%)", color: "#fff" }}>
    <tr>
      <th className="text-center" style={{ width: isTotalMode ? "8%" : "72px", height: "54px" }}>Sl. No.</th>
      <th className="text-center" style={{ width: isTotalMode ? "30%" : "220px", height: "54px" }}>Centre</th>
      <th className="text-center" style={{ width: isTotalMode ? "22%" : "150px", height: "54px" }}>Location</th>
      <th className="text-center" style={{ width: isTotalMode ? "16%" : "130px", height: "54px" }}>Mobile</th>
      <th className="text-center" style={{ width: isTotalMode ? "14%" : "140px", height: "54px" }}>Status</th>
      <th className="text-center" style={{ width: isTotalMode ? "10%" : "210px", height: "54px" }}>Action</th>
    </tr>
  </thead>

  <tbody>
    {filteredData.map((item, index) => (
      <tr key={item.id} style={{ background: index % 2 === 0 ? "#ffffff" : "#f8fafc" }}>

        <td className="text-center fw-semibold" style={{ height: "74px" }}>
          <span className="badge rounded-pill" style={{ background: "#e0f2fe", color: "#0369a1", border: "1px solid #7dd3fc" }}>
            {index + 1}
          </span>
        </td>

        <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
          <b style={{ color: "#1e40af" }}>{item.centre_name}</b><br/>
          <span className="badge px-3 py-2 mt-1" style={{ background: "#16a34a", color: "#fff", boxShadow: "0 4px 10px rgba(22,163,74,0.18)" }}>
            {item.centre_code}
          </span>
        </td>

        <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
          <span className="badge border" style={{ background: "#fef3c7", color: "#92400e", borderColor: "#fbbf24" }}>
            {item.state_name}
          </span><br/>
          <small style={{ color: "#475569" }}>{item.district_name}</small>
        </td>

        <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
          <span className="fw-bold px-2 py-1 rounded" style={{ color: "#be123c", background: "#fff1f2" }}>{item.contact}</span>
        </td>

        <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
          <span className="badge" style={statusBadgeStyle(item.status)}>
            {formatStatus(item.status)}
          </span>
          {item.status_updated_by && (item.status || "active") !== "active" ? (
            <div className="small mt-1" style={{ color: "#7c2d12", fontWeight: 700 }}>
              By: {item.status_updated_by}
            </div>
          ) : null}
          {item.status_remark ? <div className="small text-muted mt-1">{item.status_remark}</div> : null}
        </td>

        <td className="text-center" style={{ height: "74px" }}>
          <div className="d-flex flex-wrap justify-content-center gap-1">

          <button
            className="btn btn-info btn-sm"
            onClick={() => {
              setSelected(item);
              setShowView(true);
            }}
            title="View"
          >
            {isTotalMode ? <i className="bi bi-eye"></i> : "View"}
          </button>

          {!isTotalMode ? (
            <>
              <button
                className="btn btn-dark btn-sm"
                onClick={() => openFranchiseLogin(item)}
              >
                Login
              </button>

              {isActiveMode ? (
                <button className="btn btn-primary btn-sm" onClick={(event) => openActionMenu(event, item)}>
                  Action
                </button>
              ) : (
                <button className="btn btn-primary btn-sm" onClick={(event) => openActionMenu(event, item)}>
                  Action
                </button>
              )}
            </>
          ) : null}
          </div>

        </td>

      </tr>
    ))}
  </tbody>

</table>
        </div>
        </div>

{filteredData.length === 0 && (
  <div className="text-center py-4 text-muted">
    No Franchise Found
  </div>
)}

        {/* 🔥 VIEW MODAL */}
        {showView && selected && (
  <div
    style={modalStyle}
    onClick={() => {
      setShowView(false);
      setSelected(null);
    }}
  >
    <div
      style={{ ...modalContent, width: "850px" }}
      onClick={(e) => e.stopPropagation()}
    >

      <div
        className="print-area"
        style={{ padding: "25px", fontFamily: "serif" }}
      >

        {/* HEADER */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <p>To,</p>
            <p><b>The NIDCS Higher Authority</b></p>
            <p>NIDCS Head Office</p>
            <p>Srichandrapur, Bankura</p>
          </div>
        </div>

        <hr />

        <p><b>Subject:</b> Franchise Centre Approval Details</p>

        {/* DETAILS */}
        <table className="table table-bordered table-sm" style={{ borderColor: "#cbd5e1" }}>
          <tbody>
            <tr><td>Centre Name</td><td>{selected.centre_name}</td></tr>
            <tr><td>State</td><td>{selected.state_name}</td></tr>
            <tr><td>District</td><td>{selected.district_name}</td></tr>
            <tr><td>Centre Code</td><td>{selected.centre_code}</td></tr>
            <tr><td>Login ID</td><td>{selected.login_id}</td></tr>
            <tr><td>Contact</td><td>{selected.contact}</td></tr>
          </tbody>
        </table>

        {/* FOOTER */}
        <p className="mt-4">
          This is an officially approved franchise centre under NIDCS.
        </p>

      </div>

      {/* BUTTONS */}
      <div className="d-flex gap-2 mt-3">

        <button
          className="btn btn-primary btn-sm"
          onClick={handlePrint}
        >
          Print
        </button>

        <button
          className="btn btn-success btn-sm"
          onClick={handleDownload}
        >
          Download PDF
        </button>

        <button
          className="btn btn-secondary btn-sm ms-auto"
          onClick={() => {
            setShowView(false);
            setSelected(null);
          }}
        >
          Close
        </button>

      </div>

    </div>
  </div>
)}

{actionMenu && (
  <div style={modalStyle} onClick={() => setActionMenu(null)}>
    <div style={{ ...modalContent, width: "430px" }} onClick={(event) => event.stopPropagation()}>
      <h5 className="mb-2">Franchise Action</h5>
      <p className="text-muted small mb-3">
        {actionMenu.item?.centre_name} ({actionMenu.item?.centre_code})
      </p>
      <div className="d-grid gap-2">
        {(actionMenu.item?.status || "active") === "active" ? (
          <>
            <button className="btn btn-warning btn-sm" onClick={() => openLifecycleAction(actionMenu.item, "hold")}>
              Hold
            </button>
            <button className="btn btn-danger btn-sm" onClick={() => openLifecycleAction(actionMenu.item, "rejected")}>
              Reject
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => openLifecycleAction(actionMenu.item, "blacklisted")}>
              Blacklist
            </button>
          </>
        ) : (
          <button className="btn btn-success btn-sm" onClick={() => openLifecycleAction(actionMenu.item, "active")}>
            Reactivate
          </button>
        )}
        <button className="btn btn-outline-danger btn-sm" onClick={() => {
          const item = actionMenu.item;
          setActionMenu(null);
          deleteFranchise(item);
        }}>
          Delete
        </button>
      </div>
      <button className="btn btn-light btn-sm w-100 mt-3" onClick={() => setActionMenu(null)}>
        Cancel
      </button>
    </div>
  </div>
)}

{actionItem && (
  <div
    style={modalStyle}
    onClick={() => {
      setActionItem(null);
      setActionStatus("");
      setActionRemark("");
    }}
  >
    <div style={{ ...modalContent, width: "420px" }} onClick={(e) => e.stopPropagation()}>
      <h5 className="mb-2">
        {actionStatus === "active" ? "Reactivate Franchise" : `${actionStatus.charAt(0).toUpperCase()}${actionStatus.slice(1)} Franchise`}
      </h5>
      <p className="text-muted small mb-3">
        {actionItem.centre_name} ({actionItem.centre_code})
      </p>
      {actionStatus !== "active" ? (
        <>
          <label className="form-label">Remarks</label>
          <textarea
            className="form-control"
            rows="4"
            value={actionRemark}
            onChange={(e) => setActionRemark(e.target.value)}
            placeholder="Reason likhun"
          ></textarea>
        </>
      ) : (
        <div className="alert alert-success py-2">
          Reactivation korle old Centre Code / Login ID same thakbe.
        </div>
      )}
      <div className="d-flex gap-2 mt-3">
        <button className="btn btn-primary btn-sm" onClick={submitLifecycleAction}>
          Confirm
        </button>
        <button
          className="btn btn-secondary btn-sm ms-auto"
          onClick={() => {
            setActionItem(null);
            setActionStatus("");
            setActionRemark("");
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

      </div>

    </DashboardLayout>
  );
}

export default ViewFranchise;

export function HoldRejectFranchise() {
  return <ViewFranchise mode="holdRejected" />;
}

export function BlacklistedFranchise() {
  return <ViewFranchise mode="blacklisted" />;
}

export function TotalFranchise() {
  return <ViewFranchise mode="total" />;
}
